export const SET_REFERRAL_PARTNER = 'SET_REFFERAL_PARTNER';

export const setReferralPartner = (referralPartner: PartnerInfo) => ({
  type: SET_REFERRAL_PARTNER,
  data: referralPartner,
});
